/**
 * Scroll Reveal — Fade-in on scroll using IntersectionObserver
 * Lightweight, no dependencies, respects prefers-reduced-motion
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var selectors = [
    '.CategoryHome',
    '.browse-shop',
    '.feature-section',
    '.testimonials-section',
    '.case-studies-section',
    '.brand-section-wrapper',
    '.video-cards-section'
  ];

  function initReveal() {
    var elements = document.querySelectorAll(selectors.join(','));
    if (!elements.length) return;

    elements.forEach(function (el) {
      if (!el.classList.contains('scroll-reveal')) {
        el.classList.add('scroll-reveal');
      }
    });

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('revealed'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
